/* eslint-disable react-hooks/exhaustive-deps */
import useSnackbar from "hooks/useSnackbar";
import useTranslate from "hooks/useTranslate";
import { useCallback, useEffect, useState } from "react";

const useFetchPromise = <Result extends any, Data extends any = {}>(
  promise: (data: Data) => Promise<Result>,
  data?: Data
): [
  result: Result | undefined,
  fetch: (data: Data) => Promise<void>,
  isLoading: boolean
] => {
  const [result, setResult] = useState<Result>();
  const [isLoading, setIsLoading] = useState(true);
  const snackbar = useSnackbar();
  const translate = useTranslate();

  const fetchData = useCallback(
    async (data: Data) => {
      setIsLoading(true);
      try {
        const res = await promise(data);
        setResult(res);
      } catch (error: any) {
        snackbar("error", error?.message || translate("error:default"));
      } finally {
        setIsLoading(false);
      }
    },
    [promise, translate, snackbar]
  );

  useEffect(() => {
    if (data === undefined) {
      return;
    }

    fetchData(data);
  }, [data, promise]);

  return [result, fetchData, isLoading];
};

export default useFetchPromise;
